import React from 'react'
import NoDataIcon from 'assets/shared/noData.svg'
import './NoDataFallback.scss'

interface NoDataFallbackProps {
  message?: string;
}

const NoDataFallback: React.FC<NoDataFallbackProps> = ({
  message = 'No data found'
}) => {
  return (
    <div className="no-data-fallback" data-testid="no-data-fallback">
      <img src={NoDataIcon} alt="No data" className="no-data-fallback__icon" />
      <span className="no-data-fallback__text">{message}</span>
    </div>
  )
}

export default NoDataFallback

